import { boardActions } from "./board";
import { boardsActions } from "./boards";
import { clientsActions } from "./clients";
import { ticketActions } from "./ticket";
import { userActions } from "./user";
import { columnsActions } from "./columns";
import { calendarActions } from './calendar';
import { clientContactActions } from './client-contact';

import BoardReducer from "./board";
import BoardsReducer from "./boards";
import ClientsReducer from "./clients";
import TicketReducer from "./ticket";
import UserReducer from "./user";
import ColumnsReducer from "./columns";
import CalendarReducer from './calendar';
import ClientContactReducer from './client-contact';

const actions = {
    board: boardActions,
    boards: boardsActions,
    clients: clientsActions,
    user: userActions,
    ticket: ticketActions,
    columns: columnsActions,
    calendar: calendarActions,
    clientContacts: clientContactActions
}

const rootReducer = {
    board: BoardReducer,
    boards: BoardsReducer,
    clients: ClientsReducer,
    user: UserReducer,
    ticket: TicketReducer,
    columns: ColumnsReducer,
    calendar: CalendarReducer,
    clientContacts: ClientContactReducer
}

export { rootReducer, actions };